import React from 'react'
import { Container, ChannelName, SupportInfo, Title, Value } from './styles'
import {
  SUPPORT_EMAIL_ADDRESS,
  SUPPORT_EMAIL_ADDRESS_LINK,
  SUPPORT_PHONE_NUMBER,
  SUPPORT_WHATSAPP_PHONE_LINK,
  SUPPORT_WHATSAPP_PHONE_NUMBER
} from '~/constants'

interface SupportChannelProps {
  label: string
  value: string
  href?: string
}

const SupportChannel = ({ label, value, href }: SupportChannelProps): JSX.Element => {
  return (
    <SupportInfo>
      <ChannelName>{label}:</ChannelName>
      <Value as={href ? 'a' : 'span'} href={href} target="_blank">
        {value}
      </Value>
    </SupportInfo>
  )
}

interface SupportContactProps {
  isCollapsed: boolean
}

export const SupportContact = ({ isCollapsed }: SupportContactProps): JSX.Element => {
  return (
    <Container isCollapsed={isCollapsed}>
      <Title>Suporte</Title>

      <SupportChannel label="Telefone" value={SUPPORT_PHONE_NUMBER} />
      <SupportChannel label="Whatsapp" value={SUPPORT_WHATSAPP_PHONE_NUMBER} href={SUPPORT_WHATSAPP_PHONE_LINK} />
      <SupportChannel label="E-mail" value={SUPPORT_EMAIL_ADDRESS} href={SUPPORT_EMAIL_ADDRESS_LINK} />
    </Container>
  )
}
